"use client";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "../ui/button";
import { MenuItems } from "@/src/data/types";
import { AppbarTexts } from "../AppbarTexts";
import { Link } from "react-router-dom";

type MobileMenuProps = {
  navMenu?: MenuItems[];
};

const MobileMenu: React.FC<MobileMenuProps> = ({ navMenu = [] }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCloseMenu = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <div className="relative block md:hidden ">
        <div onClick={handleDropdownToggle} className="cursor-pointer">
          <div className="ml-4 cursor-pointer hover:text-primary">
            {isOpen ? <X /> : <Menu />}
          </div>
        </div>
        {isOpen && (
          <div className="fixed top-0 bottom-0 right-0 z-50 transition-opacity duration-500 ease-in-out bg-white shadow-md">
            <div className="flex justify-end px-4 py-2">
              <div
                className="cursor-pointer hover:text-primary"
                onClick={handleCloseMenu}
              >
                <X />
              </div>
            </div>
            {navMenu &&
              navMenu.map((item) => (
                <div onClick={handleCloseMenu}>
                  <AppbarTexts
                    className="!flex-[0_0_auto]"
                    property1="variant-3"
                    text={item.title}
                    url={item.url}
                  />
                </div>
              ))}

            <div className="p-2">
              <Link to={"/contact"}>
                <Button className="text-white shadow-md bg-primary w-44 shadow-gray-400 ">
                  Contact
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
